import React, {Component} from 'react';
import { Link } from 'react-router'
import ContactForm from '../../components/ContactForm';

export default class Contact extends Component {

  render() {
    return (
      <div className="Contact">
        <h1>Contact Us</h1>
        <p>If you would like to contact us, please send us a message using the following form.</p>
        <ContactForm />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Contact/Contact.js